import oRequest from '@/libsV2/request.js';

const URL = {
    SEARCH_TOPTAG       : 'dataview/search/toptag',//合同类型
    SEARCH_REGION       : 'dataview/search/region',//大区
    SEARCH_DEFAULT_DATE : 'dataview/search/defaultdate',//日期范围
    // SEARCH_DISTRICT     : 'dataview/search/district',//省市
    SEARCH_DISTRICT     : 'dataview/searchv2/district',//省市
    SEARCH_BUSINESS     : 'dataview/search/business',//代理商
    INDEX_BOARD         : 'dataview/index/board',//看板数据
    INDEX_USER_LOG      : 'dataview/index/userlog',//首页-用户日志
    SEARCH_USER_LOG     : 'dataview/search/userlog',//搜索-用户日志
    DATAVIEW_USER_INFO  : 'dataview/index/userinfo',//用户信息
    BORD_INFO:'/dataview/board/index',//头部用户交付信息
    BORD_USERINFO:'/dataview/board/userinfo',//用户个人信息
    USER_INFO:'dataview/board/userdelivery',//用户详情
}

export default {
    userInfoDetail(data = {}) {
        let oData = Object.assign({}, data);
        return oRequest.getData(URL.USER_INFO, oData)
    },
    bordUserInfo(data = {}) {
        let oData = Object.assign({}, data);
        return oRequest.getData(URL.BORD_USERINFO, oData)
    },
    bordInfo(data = {}) {
        let oData = Object.assign({}, data);
        return oRequest.getData(URL.BORD_INFO, oData)
    },
    getDataviewInfo(data = {}) {
        let oData = Object.assign({}, data);
        return oRequest.getData(URL.DATAVIEW_USER_INFO, oData)
    },
    getSearchToptag(data = {}) {
        let oData = Object.assign({}, data);
        return oRequest.getData(URL.SEARCH_TOPTAG, oData)
    },
    getSearchRegion(data = {}){
        let oData = Object.assign({}, data);
        return oRequest.getData(URL.SEARCH_REGION, oData)
    },
    getSearchDefaultDate(data = {}){
        let oData = Object.assign({}, data);
        return oRequest.getData(URL.SEARCH_DEFAULT_DATE, oData)
    },
    getSearchDistrict(data ={}){
        let oData = Object.assign({}, data);
        return oRequest.getData(URL.SEARCH_DISTRICT, oData)
    },
    getSearchBusiness(data = {}){
        let oData = Object.assign({}, data);
        return oRequest.getData(URL.SEARCH_BUSINESS, oData)
    },
    getIndexBoard(data = {}){
        let oData = Object.assign({}, data);
        return oRequest.getData(URL.INDEX_BOARD, oData)
    },
    getIndexUserLog(data = {}){
        let oData = Object.assign({}, data);
        return oRequest.getData(URL.INDEX_USER_LOG, oData)
    },
    getSearchUserLog(data = {}){
        let oData = Object.assign({}, data);
        return oRequest.getData(URL.SEARCH_USER_LOG, oData)
    }
}
